import * as React from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import { GridMetric } from "../general/custom";
import { formatTime } from "../../scripts/utils";
import { fetchDeviceDetail } from "../../scripts/api_v2/commands_client";
import { useQuery } from "@tanstack/react-query";
import { REACT_QUERY_KEYS } from "../../enums/react_query_key_enum";
import useBackend from "../../hooks/use_backend";
import { useParams } from "react-router-dom";

export function BatteryLiveData({ deviceId }) {
  const params = useParams();
  const backend = useBackend();

  const {
    data: data,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [REACT_QUERY_KEYS.DEVICE_DETAIL, backend.fetch, params.site_id, deviceId],
    queryFn: () => fetchDeviceDetail(backend.fetch, params.site_id, deviceId),
    refetchInterval: 5000,
  });

  const timestamp = data && data.metering ? new Date().getTime() / 1000 : null;

  return (
    <Grid container>
      {data && data.metering ? (
        Object.keys(data.metering)
          .sort()
          .map((key) => <GridMetric key={key} name={key} value={parseInt(data.metering[key])} />)
      ) : (
        <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      )}
      {data ? <GridMetric name={"reading time"} value={formatTime(new Date(timestamp * 1000))} /> : null}
    </Grid>
  );
}
